/* eslint-disable no-mixed-spaces-and-tabs */
import { SubmissionError } from 'redux-form';
import { goToElement } from '../../utils/goToElement';
import { FROM_POINT_REQUIRED_FIELDS, ORDERS_FORM_REQUIRED_FIELDS, TO_POINT_REQUIRED_FIELDS } from './constants';

export const transformToValidationErrors = errors => {
	goToElement(Object.keys(errors)[0]);
	return Object.entries(errors).reduce((prev, [key, error]) => {
		if (!prev[key]) {
			prev[key] = {};
		}
		if (key.includes('points') && key !== 'points') {
			const arr = key.replace('_', '.').split('.');
			if (!prev.points) {
				prev.points = {};
			}
			prev.points = {
				...prev.points,
				[arr[1]]: {
					...(prev.points[arr[1]] || {}),
					[arr[2]]: !arr[3]
						? error
						: {
								id: error,
						  },
				},
			};
		}
		prev[key] = error;
		return prev;
	}, {});
};

const validatePoint = (values, key, index, fields) => {
	fields.forEach(field => {
		if (
			(field === 'date' && !values?.points?.[index]?.[field]) ||
			(field !== 'date' && !values?.points?.[index]?.[field]?.id)
		) {
			const error = { points: [] };

			if (field === 'date') {
				error.points[index] = { [field]: 'Заполните это поле' };
				goToElement(`${key}.${field}`);
			} else {
				error.points[index] = { [field]: { id: 'Заполните это поле' } };
				goToElement(`${key}.${field}.id`);
			}
			throw new SubmissionError(error);
		}
	});
};

export const validate = values => {
	ORDERS_FORM_REQUIRED_FIELDS.forEach(key => {
		if (key === 'mode.id' && !values?.mode?.id) {
			goToElement('mode.id');
			throw new SubmissionError({
				mode: {
					id: 'Заполните это поле',
				},
			});
		}

		if (key === 'points.0') {
			validatePoint(values, 'points[0]', 0, FROM_POINT_REQUIRED_FIELDS);
		}
		if (key === 'points.1') {
			validatePoint(values, 'points[1]', 1, TO_POINT_REQUIRED_FIELDS);
		}

		if (
			(values?.[key] === undefined || values?.[key] === '' || !values?.[key]) &&
			!['points.0', 'points.1', 'mode.id'].includes(key)
		) {
			goToElement(key);
			throw new SubmissionError({ [key]: 'Заполните это поле' });
		}
	});
};
